import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { DataService } from '@app/data';

@Component({
  selector: 'app-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.less']
})
export class ChipComponent {

  @Input() chip?: any;
  @Input() selectable?: boolean;

  constructor(
    private data: DataService
  ) {}

  public getChipQueryParams(chip: any): any {
    //console.log('ChipsComponent chip ', chip);

    let param;

    switch (chip.entityBundle) {

      case 'schools': {
          param = { skoly: [chip!.entityUrl!.path!] };
        break;
      }

      case 'partners': {
          param = { partneri: [chip!.entityUrl!.path!] };
        break;
      }

      case 'tags': {
          param = { stitky: [chip!.entityUrl!.path!] };
        break;
      }
    }

    return param;
  }
}
